import { BackgroundColors } from '@/@types/types';

export default {
  path: '/business-glossary',
  name: 'business-glossary',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.business-glossary',
    background: BackgroundColors.SECONDARY,

  },
  component: () => import('@/views/FrontendNextRouteView.vue'),
};
